export var source = "fragment ProductNotes on Product {\n  notes {\n    id\n    name\n    image\n    slug\n  }\n}";
export default source;